import { render, staticRenderFns } from "./Ladder.vue?vue&type=template&id=cdbbabb0&scoped=true"
import script from "./Ladder.vue?vue&type=script&lang=js"
export * from "./Ladder.vue?vue&type=script&lang=js"
import style0 from "./Ladder.vue?vue&type=style&index=0&id=cdbbabb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbbabb0",
  null
  
)

export default component.exports